import React from "react";
import { ReactComponent as Star } from "design_system/src/static/icons/star.svg";
import { ReactComponent as StarFilled } from "design_system/src/static/icons/star-filled.svg";

interface ReviewScoreProps {
  value?: number;
}

const ReviewScore = ({ value }: ReviewScoreProps) => {
  if (value === undefined || !(value >= 0 || value <= 5)) return null;

  return (
    <div className="display_flex flex_nowrap">
      {value >= 1 ?
        <StarFilled className="text_primary_300" />
        : <Star className="text_primary_300" />
      }
      {value >= 2 ?
        <StarFilled className="text_primary_300" />
        : <Star className="text_primary_300" />
      }
      {value >= 3 ?
        <StarFilled className="text_primary_300" />
        : <Star className="text_primary_300" />
      }
      {value >= 4 ?
        <StarFilled className="text_primary_300" />
        : <Star className="text_primary_300" />
      }
      {value === 5 ?
        <StarFilled className="text_primary_300" />
        : <Star className="text_primary_300" />
      }
    </div>
  );
};

export default ReviewScore;
